/**
 * The external dependencies.
 */
import {combineReducers} from 'redux';
import {handleActions} from 'redux-actions';
import * as R from 'ramda';
/**
 * The internal dependencies.
 */
import {authCheckLogin, authCheckLoginReceived, authLogout, authReceiveLogin, setConfig, unsetConfig,} from './actions';

const user = handleActions({
    [authReceiveLogin]: (state, {payload: {userData}}) => userData,
    [authCheckLogin]: (state, payload) => state,
    [authCheckLoginReceived]: (state, payload) => state,
    [authLogout]: () => null, // Currently non-api implementation
}, {});

const quality = handleActions({
    [authReceiveLogin]: (state, {payload: {userData}}) => {
        if (userData.grantedauthority === 'ROLE_QA' || userData.grantedauthority === 'ROLE_ADMIN') {
            return true;
        } else {
            return false;
        }
    },
}, false);

const disponent = handleActions({
    [authReceiveLogin]: (state, {payload: {userData}}) => {
        if (userData.grantedauthority === 'ROLE_DISPO'
            || userData.grantedauthority === 'ROLE_OPMANAGER'
            || userData.grantedauthority === 'ROLE_ADMIN') {
            return true;
        } else {
            return false;
        }
    },
}, false);

const opmanager = handleActions({
    [authReceiveLogin]: (state, {payload: {userData}}) => {
        if (userData.grantedauthority === 'ROLE_OPMANAGER') {
            return true;
        } else {
            return false;
        }
    },
}, false);

const freeUser = handleActions({
    [authReceiveLogin]: (state, {payload: {userData}}) => {
        if (R.isNil(userData.departmentEntity) || R.isEmpty(userData.departmentEntity)) {
            return true;
        } else {
            return false;
        }
    },
}, false);

const config = handleActions({
    [setConfig]: (state, {payload: {config}}) => {
        return config;
    },
    [unsetConfig]: () => {
        return [];
    },
}, []);

const randomWorksteps = handleActions({
    [setConfig]: (state, {payload: {config}}) => {
        if (config['randomworksteps'] !== undefined && config['randomworksteps'] === 'true') {
            return true;
        }
        ;
        return false;
    },
    [unsetConfig]: () => {
        return false;
    },
}, false);

const noworkplace = handleActions({
    [setConfig]: (state, {payload: {config}}) => {
        if (config['noworkplace'] !== undefined && config['noworkplace'] === 'true') {
            return true;
        }
        ;
        return false;
    },
    [unsetConfig]: () => {
        return false;
    },
}, false);

const disponentnext = handleActions({
    [setConfig]: (state, {payload: {config}}) => {
        if (config['disponentnext'] !== undefined && config['disponentnext'] === 'true') {
            return true;
        }
        ;
        return false;
    },
    [unsetConfig]: () => {
        return false;
    },
}, false);

export default combineReducers({
    user,
    quality,
    disponent,
    freeUser,
    config,
    randomWorksteps,
    noworkplace,
    disponentnext,
    opmanager,
});



// WEBPACK FOOTER //
// ./src/store/auth/reducer.js